import React from 'react';
import styled, { css } from 'styled-components';

import { placeholderAnimationCss } from '@tager/web-components';

import { media } from '@/utils/mixin';

import PricePlaceholder from './components/PricePlaceholder';
import ButtonsPlaceholder from './components/ButtonsPlaceholder';
import BadgesPlaceholder from './components/BadgesPlaceholder';
import TagsPlaceholder from './components/TagsPlaceholder';

interface Props {
  className?: string;
}

function SidePanelPlaceholder({ className }: Props) {
  return (
    <Component className={className}>
      <Container>
        <Title />
        <Subtitle />
        <TagsPlaceholder />
        <ColorPlaceholder />
        <BadgesPlaceholder />
        <StatusPlaceholder />
        <PricePlaceholder />
        <ButtonsPlaceholder />
        <BannerPlaceholder />
      </Container>
    </Component>
  );
}

export default SidePanelPlaceholder;

const Component = styled.div`
  flex: 1 1 460px;
  max-width: 460px;
  margin-left: 40px;

  ${media.tablet(css`
    flex: auto;
    max-width: none;
    margin: 25px 0 0;
  `)}
`;

const Container = styled.div`
  position: sticky;
  top: 25px;
`;

const Title = styled.div`
  height: 30px;
  width: 300px;
  margin: 3.3px 0;
  border-radius: 8px;
  ${placeholderAnimationCss}

  ${media.laptopOnly(css`
    height: 26px;
    width: 200px;
    margin: 2px 0;
  `)}

  ${media.mobile(css`
    height: 15px;
    width: 150px;
    margin: 2px 0;
  `)}
`;

const Subtitle = styled.div`
  height: 30px;
  width: 150px;
  margin: 3.3px 0;
  border-radius: 8px;
  ${placeholderAnimationCss}

  ${media.laptopOnly(css`
    height: 19px;
    width: 50px;
    margin-top: 6px;
  `)}
  
  ${media.mobile(css`
    height: 15px;
    width: 150px;
    margin: 2px 0;
  `)}
`;

const ColorPlaceholder = styled.div`
  width: 320px;
  height: 32px;
  border-radius: 8px;
  margin-top: 15px;
  ${placeholderAnimationCss}

  ${media.laptopOnly(css`
    height: 18px;
    width: 150px;
  `)}

  ${media.mobile(css`
    height: 18px;
    width: 150px;
  `)}
`;

const StatusPlaceholder = styled.div`
  margin-top: 10px;
  height: 20.7px;
  width: 100px;
  border-radius: 8px;
  ${placeholderAnimationCss}

  ${media.laptopOnly(css`
    height: 18px;
    width: 150px;
  `)}

  ${media.mobile(css`
    height: 20px;
    width: 150px;
  `)}
`;

const BannerPlaceholder = styled.div`
  margin-top: 20px;
  width: 100%;
  height: 141px;
  border-radius: 15px;
  ${placeholderAnimationCss}

  ${media.laptopOnly(css`
    height: 94px;
  `)}
`;
